import { useEffect, useMemo, useState } from "react";
import { Stack, Typography, useTheme } from "@mui/material";
import { SearchBar } from "@app/components";
import { useDispatch } from "react-redux";
import { useRequestState } from "@app/hooks";
import { selectBrandState } from "@app/modules/categories/selector";
import { findModelById } from "@app/modules/categories/slice";

const Model = ({ methods }: any) => {
  const theme = useTheme();
  const dispatch = useDispatch();
   const [searchTerm , setSearchTerm] = useState("");

  const { data } = useRequestState({
    stateSelector: selectBrandState,
  });

  const brandId = methods.watch("brandId");
  const modelId = methods.watch("modelId");

  const selectedBrand = useMemo(
    () => data?.find((brand: any) => brand.id === brandId),
    [data, brandId]
  );

  const models = selectedBrand?.models || [];

  useEffect(() => {
    if (brandId && (!selectedBrand?.models || selectedBrand.models.length === 0)) {
      dispatch(findModelById({ id: brandId }));
    }
  }, [brandId, selectedBrand, dispatch]);

   const filteredModels = models?.filter((item:any)=>{ 
    if(searchTerm === "") return true
    return  item?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  })
  

  const handleSelectModel = (item: any) => {
    methods.setValue("modelId", item.id, { shouldValidate: true });
  };

  return (
    <>
      <Stack
        sx={{
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          pt: 2,
        }}
      >
        <Typography sx={{ fontSize: 24, fontWeight: "bold" }}>
          Select Car Model
        </Typography>
        <Typography variant="body1" sx={{ color: theme.palette.grey[500] }}>
          Choose the model for your selected brand
        </Typography>
        <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
      </Stack>

      <Stack
        sx={{
          mt: 5,
          mb: 2,
          flexDirection: "row",
          flexWrap: "wrap",
          gap: 2,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {filteredModels.length === 0 ? (
          <Typography color="error">
            No model found for this brand.
          </Typography>
        ) : (
          filteredModels?.map((item: any) => {
            const isSelected = modelId === item.id;
            return (
              <Stack
                key={item.id}
                onClick={() => handleSelectModel(item)}
                sx={{
                  border: "2px solid",
                  borderColor: isSelected
                    ? theme.palette.primary.main
                    : theme.palette.grey[300],
                  borderRadius: 2,
                  cursor: "pointer",
                  backgroundColor: isSelected
                    ? theme.palette.primary.light
                    : "transparent",
                  p: 2,
                  width: 180,
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.05)",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    color: isSelected
                      ? theme.palette.common.white
                      : theme.palette.grey[900],
                    textAlign: "center",
                  }}
                >
                  {item.name}
                </Typography>
              </Stack>
            );
          })
        )}
      </Stack>
      {methods.formState.errors?.modelId && (
        <Typography color="error" textAlign="center" mt={2} fontWeight={600}>
          {methods.formState.errors.modelId.message}
        </Typography>
      )}
    </>
  );
};

export { Model };
